import styled from "styled-components";
import {styledByDevice} from "../../../../../../themes/architecture/styled-by-device";
import { LiveCasinoGridDefaultBox } from "./live-casino-grid.default.box";

const PCBox = styled(LiveCasinoGridDefaultBox)`
    &:before {
        background-size: cover;
        top: 0;
        height: 35rem;
    }
`;

const MobileBox = styled(PCBox)`
    &:before {
        display: block;
        opacity:1;
        top: 0;
    }
`;

export const LiveCasinoGridCasino777Box = styledByDevice(PCBox, MobileBox);